export const collaborativeArticles = [
  {
    id: 5,
    titles: {
      en: "Therapeutic Assessment in Personality Disorders: Toward the Restoration of Epistemic Trust",
      it: "Assessment Terapeutico nei Disturbi di Personalità: Verso il Ripristino della Fiducia Epistemica"
    },
    authors: ["Kamphuis Jan", "Finn Stephen"],
    descriptions: {
      en: "This groundbreaking work explores how therapeutic assessment can restore epistemic trust in individuals with personality disorders, providing a collaborative framework for assessment that promotes therapeutic change.",
      it: "Questo lavoro rivoluzionario esplora come l'assessment terapeutico possa ripristinare la fiducia epistemica negli individui con disturbi di personalità, fornendo un quadro collaborativo per la valutazione che promuove il cambiamento terapeutico."
    },
    publishDate: "2024-01-30",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/6a123934-a623-4c40-83f1-5cbc96ac8b7e/introduction-to-therapeutic-assessment",
        mindmap: "https://whimsical.com/R41ytFj8kJze8gmijdDoaM",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8wLzEvMS8wMDowMDowMC80NzYzODcxLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/bbfbcc5e-b75b-4419-9bef-e5f73368d601/introduzione-valutazione-terapeutica",
        mindmap: "https://whimsical.com/valutazione-terapeutica-kamphuis-and-finn-Vopjottg5yoqBZcB5VVBT8",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTExMTQ1My8x"
      }
    }
  },
  {
    id: 6,
    titles: {
      en: "Therapeutic Assessment in Personality Disorders: Building Trust and Reducing Hypervigilance",
      it: "Assessment Terapeutico nei Disturbi di Personalità: Costruire Fiducia e Ridurre l'Ipervigilanza"
    },
    authors: ["Kamphuis Jan", "Finn Stephen"],
    descriptions: {
      en: "An exploration of therapeutic assessment techniques specifically designed to build trust and reduce hypervigilance in clients with personality disorders, emphasizing collaborative approaches to psychological evaluation.",
      it: "Un'esplorazione delle tecniche di assessment terapeutico specificamente progettate per costruire fiducia e ridurre l'ipervigilanza nei clienti con disturbi di personalità, enfatizzando approcci collaborativi alla valutazione psicologica."
    },
    publishDate: "2024-02-25",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/b09a4f39-b8da-4801-8c8b-a0860a254bc8/introduction-to-therapeutic-assessment",
        mindmap: "https://whimsical.com/HG8QF5uF6djGWAVeHPQ2L6",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8wLzEvMS8wMDowMDowMC80NzYzODc3LzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/9ae48570-03e7-49a7-963c-788b907474b3/introduzione-valutazione-terapeutica",
        mindmap: "https://whimsical.com/therapeutic-assessment-e-fiducia-epistemica-4tW3CWmqXYB7222CLyTc71",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8wLzAvMS8xLzEvMDA6MDA6MDAvNTEwODgyMy8x"
      }
    }
  },
  {
    id: 7,
    titles: {
      en: "Using the Rorschach as a Group Intervention to Promote the Understanding of Adolescents by Staff Members in Inpatient Residential Programs",
      it: "Utilizzo del Rorschach come Intervento di Gruppo per Promuovere la Comprensione degli Adolescenti da Parte del Personale nei Programmi Residenziali"
    },
    authors: ["Aschieri Filippo", "Vetere Carlo"],
    descriptions: {
      en: "This innovative study explores the application of the Rorschach test as a group intervention tool to enhance staff understanding of adolescent patients in residential treatment settings, demonstrating how collaborative assessment can bridge therapeutic relationships.",
      it: "Questo studio innovativo esplora l'applicazione del test di Rorschach come strumento di intervento di gruppo per migliorare la comprensione del personale dei pazienti adolescenti in contesti di trattamento residenziale, dimostrando come l'assessment collaborativo possa costruire ponti nelle relazioni terapeutiche."
    },
    publishDate: "2024-03-20",
    availableLanguages: ['en'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/ec9e0254-d50d-427b-a004-219fc89dfaac/introduction-reflecting-rorschach-group-intervention",
        mindmap: "https://whimsical.com/ESWLt9YZECorVHMv2Hsd9x",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMC8wMDowMDowMC80NzQxMDM2LzE="
      }
    }
  },
  {
    id: 26,
    titles: {
      en: "Rorschach Coding Dilemmas as Access to Psychological Processes",
      it: "I dilemmi di codifica nel Rorschach come accesso ai processi psicologici"
    },
    authors: ["Constance T. Fischer"],
    descriptions: {
      en: "An in-depth exploration of Rorschach coding dilemmas and how they provide access to understanding underlying psychological processes, offering insights into the complexity of psychological assessment and interpretation.",
      it: "Un'esplorazione approfondita dei dilemmi di codifica nel Rorschach e come questi forniscano accesso alla comprensione dei processi psicologici sottostanti, offrendo intuizioni sulla complessità della valutazione e interpretazione psicologica."
    },
    publishDate: "2024-05-30",
    availableLanguages: ['en', 'it'],
    resources: {
      en: {
        blogpost: "https://www.videotopage.com/p/8c3b71a1-e955-431d-92b8-32c65a191a1b/introduction-fishers-rorschach-perspective",
        mindmap: "https://whimsical.com/generated-board-BhmDW1ktHie8RWZCEusM8W",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uLzEvMC8xLzEvMS8wMDowMDowMC81MjQ4MzcwLzE="
      },
      it: {
        blogpost: "https://www.videotopage.com/p/e2a3ac4e-2f91-412d-87ce-c50da20313a7/introduzione-dinamiche-punteggio-rorschach",
        mindmap: "https://whimsical.com/generated-board-YTC6Wc6PYvabdSaxjguuca",
        podcast: "https://embed.disctopia.com/podcast/Y29zbW9fZWR1Y2F0aW9uX2l0YWxpYS8xLzAvMS8xLzEvMDA6MDA6MDAvNTI2OTUxOS8x"
      }
    }
  }
];